import { render, staticRenderFns } from "./BtnPdf.vue?vue&type=template&id=3705a62c&"
import script from "./BtnPdf.vue?vue&type=script&lang=js&"
export * from "./BtnPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports